function ua_addclass() {
	jQuery(function () {
		var ua = navigator.userAgent;
		if (ua.indexOf("iPhone") > 0 || ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0) {
			jQuery("body").addClass("ua_sp"); // sp
		} else if (ua.indexOf("iPad") > 0 || ua.indexOf("Android") > 0) {
			jQuery("body").addClass("ua_tb"); // tablet
		} else {
			jQuery("body").addClass("ua_pc"); // pc
		}
	})
}
export default {ua_addclass}